import crypto from 'crypto';

export default ({ app, $config }, inject) => {
    const encrypt = (data) => {
        return crypto.publicEncrypt($config.public_key, Buffer.from(data)).toString('base64');
    };
    inject('encrypt', encrypt);
};